import { render } from "./UserCardsSkeleton.vue?vue&type=template&id=3924c909&ts=true"
import script from "./UserCardsSkeleton.vue?vue&type=script&lang=ts"
export * from "./UserCardsSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__